import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTags from '@/components/MetaTags';
import useMetaTags from '@/hooks/useMetaTags';
import { useTheme } from '@forma/forma-ui-theme';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';

import mockApi from '@/api/mockApi';
import { getLegalDocumentHtml, LEGAL_DOCUMENT_CACHE_CONTROL } from '@/helpers/legalDocuments';

import styles from '../StaticPage.module.css';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    LEGAL_DOCUMENT_CACHE_CONTROL
  );
  const mainData = await mockApi.getMainData(params.locale);
  const pageData = await getLegalDocumentHtml(params.locale, 'privacy', 'privacy');
  const headersParse = await getHeadersFromServer(req);
  return {
    props: {
      initialState: {
        main: mainData,
      },
      privacy: pageData,
      headersParse,
      ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
    },
  };
};

const ContentPage = ({ privacy }) => {
  const { t } = useTranslation();

  const metaData = {
    title: t('meta_titles.privacy'),
    description: t('meta_descriptions.privacy'),
    keywords: t('main_keywords'),
  };
  const { lang } = useTheme();
  useMetaTags({ lang, ...metaData });

  return (
    <div className="container">
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      {privacy &&
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: privacy }} />
      }
    </div>
  );
};

export default ContentPage;
